import { PricingCard } from './pricing-card';
import { ProtectionPricingCard } from './protection-pricing-card';

export class DefaultPricingCards {
	protectionPricingCards: ProtectionPricingCard[];
	pricingCards: PricingCard[];
}
